require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./effect-of-police-enforcement-on-roadway-safety.json") })
        }
      }, "path---effect-of-police-enforcement-on-roadway-safety");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---effect-of-police-enforcement-on-roadway-safety!./.cache/json/effect-of-police-enforcement-on-roadway-safety.json
// module id = 886
// module chunks = 231608221292675